var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.dark}},[(_vm.profile !== null)?_c('AsideMenu'):_vm._e(),(_vm.profile !== null)?_c('ToolbarMenu'):_vm._e(),_c('v-content',{attrs:{"app":""}},[_c('router-view')],1),_c('snackbars'),_c('Confirmation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }